import Customer from '@/models/customer'

export default class CustomerFactory {
    static createFromJson(json) {
        return new Customer(json)
    }
    static createFromJsonArray(jsonArray) {
        const jsonData = []
        jsonArray.forEach(item => {
            jsonData.push(CustomerFactory.createFromJson(item))
        })

        return jsonData
    }
}
